import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const itemsApi = createApi({
  reducerPath: 'itemsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Items', 'Equipped'],
  endpoints: (builder) => ({
    getItems: builder.query({
      query: (type = 'avatar') => ({ url: '/items', params: { type } }),
      providesTags: ['Items'],
    }),
    equipItem: builder.mutation({
      query: ({ slot, item_id }) => ({
        url: '/users/me/equip',
        method: 'POST',
        body: { slot, item_id },
      }),
      invalidatesTags: ['Items', 'Equipped'],
    }),
  }),
});

export const { useGetItemsQuery, useEquipItemMutation } = itemsApi;
